import React from 'react'
import { Button } from 'react-bootstrap'
import EditIcon from '@material-ui/icons/Edit';

const Editar = (props) => {
    return (
        <>
         <Button variant="secondary" size="sm" style={{ width: 115 }} onClick={() => { props.setDisabled(false); props.setVerDomicilio && props.setVerDomicilio(false); props.setVerDatosPersonales && props.setVerDatosPersonales(false); }}><EditIcon /> Editar</Button>   
        </>
    )
}

export default Editar;